module.exports = __webpack_public_path__ + "static/media/figma.ac00fa7b.png";